import { TemplatesTranslations } from '../models/templates.translations.interface';

export const templatesTranslationsEN: TemplatesTranslations = {
  tool_info:
    '{{tools}}} tools have already been created based on this template. Changes to the template also change the created tools!',
  input_setting: {
    title: 'Choose input type',
    select: 'Input type selection',
    category: {
      single: 'Single line text field',
      multi: 'Multi-line body text',
      number: 'Number field',
      number_for: 'Number field (for calculations)',
    },
    date: 'Date',
    date_time: 'Date and Time',
    duration: 'Duration (hh:mm)',
    time: 'Time',
    email: 'E-mail',
    telephone: 'Phone number',
    url: 'Url',
    point: 'Thousand point',
    suffix: 'Suffix (e.g. km, hours, ..)',
    set_suffix: 'Validate syntax in frontend',
  },
  actions: {
    delete: 'Vorlage löschen',
    delete_check: {
      title: 'Delete Template',
      subtitle: 'The template will be deleted and cannot be restored.',
    },
    delete_success: 'Die Hilfsmittelvorlage wurde gelöscht!',
    finish: 'Bearbeitung beenden',
    publish: 'Veröffentlichen',
    no_publish: {
      title: 'Nicht mehr veröffentlichen',
      success: 'Deine Hilfsmittelvorlage ist nun nicht mehr veröffentlicht.',
    },
    print: 'Neue Druckansicht',
    settings: 'Einstellungen',
    update: {
      error: 'Fehler beim Speichern der Hilfsmittelvorlage',
      title: 'Speichern / Aktualisieren',
    },
  },
  elements: {
    create: {
      abort: 'End element edit?',
      content: {
        form: {
          label: 'Content',
        },
        subtitle: 'Set the content to be displayed',
        title: 'Content',
      },
      headline: {
        form: {
          label: 'Headline',
          placeholder: 'e.g. agenda',
        },
        subtitle: 'What should your headline be?',
        title: 'Headline',
      },
      image: {
        subtitle: 'Upload your image to be displayed',
        title: 'Image upload',
      },
      name: {
        form: {
          description: {
            label: 'Description (displayed under the title)',
            placeholder:
              'This is an example description to show you what your categories will look like. Descriptions are always below the designation and above the input element.',
          },
          name: {
            placeholder: 'e.g. agenda',
            sublabel: 'Label (displayed above the element)',
          },
          help_text: {
            placeholder: 'Examples or further explanations.',
            label: 'Help text (blue help icon next to the name)',
          },
        },
        subtitle: 'Give your element a name',
        title: 'Name',
      },
      section: {
        form: {
          description: {
            label: 'Description (displayed under the title)',
            placeholder:
              'This is an example description to show you what your categories will look like. Descriptions are always below the designation and above the input element.',
          },
          name: {
            placeholder: 'e.g. agenda',
            sublabel: 'Label (displayed above the element)',
          },
        },
        subtitle: 'Give your element a name',
        title: 'Name',
      },
      options: {
        form: {
          add: 'Add new option',
          color: '+ Color',
          placeholder: 'e.g. low',
        },
        subtitle: 'Define the selection options to be displayed',
        title: 'Options',
      },
      vote: {
        form: {
          add: 'Add star',
          remove: 'Remove star',
          placeholder: '',
        },
        subtitle: 'Define the selection options to be displayed',
        title: 'Options',
      },
      settings: {
        form: {
          advanced: {
            auto_date: 'Automatically prefill with the current date',
            auto_select: 'Automatic selection if users from a certain group',
            connected_contact: 'This element displays groups of people.',
            date_with_time: 'Add an additional time',
            label: 'Advanced Settings',
            only_edit_own_posts: 'Only own posts can be edited',
            only_show_employees: 'Show only employees to choose from',
            only_show_members: 'Show only members to choose from',
            only_show_own_posts:
              'Only own entries are visible (admin sees all)',
            required: 'Mark this item as required',
            only_image: 'This element should only allow images!',
            only_film: 'Dieses Element soll nur Filme erlauben! (Bsp.: .mp4)',
            only_office:
              'Dieses Element soll nur Office-Dateien erlauben! (Bsp.: .docx)',
            only_archive:
              'Dieses Element soll nur Archive erlauben! (Bsp.: .zip)',
            only_one_image: 'This item should only allow 1 file!',
            small_image:
              'This element is only half as wide (next element is next to it)!',
            contact_card: 'Show contact as business card',
            vote_change: 'Rating changeable',
            vote_result: 'Show result for voter after voting.',
            n_posts: 'Der Benutzer kann n-Einträge erstellen',
            n_posts_sub:
              '(keine Eingabe oder 0 kann beliebig viele Einträge erstellen)',
            toggle_false_string: 'An/Aus-Schalter Label "Nein"',
            toggle_true_string: 'An/Aus-Schalter Label "Ja"',
            value_show_in_other_tool:
              'Daten für ein anderes Hilfsmittel bereitstellen.',
            show_only_for_admin: 'This element is only for community-admins.',
            only_admin_can_post: 'Nur Admin kann Einträge erstellen.',
            only_admin_can_edit: 'Nur Admin kann bearbeiten.',
            show_at_arccordion_header: 'Element im Akkordeon-Header anzeigen.',
          },
          list: {
            employees: 'Show content as column in Network',
            label:
              'Choose whether the content of the item should be displayed as a column in the Network once this tool is assigned to a person',
            members: 'Show content as column in member list',
          },
          multi_element_table: {
            tile_view: 'Tile view of the images',
          },
          rights: {
            employee: 'Employee',
            label: 'Who can edit and fill out this element?',
            member: 'member',
            pengueen_admin: 'Pengueen Admin',
          },
          export: {
            export_with_id: 'ID with output during export',
            disable_export: 'Do not export element',
            label: 'Export settings',
            sublabel: 'Include this element during export',
          },
        },
        subtitle:
          'Wähle erweiterte Einstellungen und Rechte für dieses Element',
        title: 'Settings and rights',
      },
      summary: 'Summary',
      type: {
        subtitle: 'What kind of element do you want to create?',
        title: 'Element',
      },
      title: 'Properties of the new element',
      edit_title: 'Properties of {{templateName}}',
      element: 'the element',
      view_changes: 'View changes',
    },
    group: {
      error: 'Fehler beim Gruppieren von Elementen:',
      success: 'Elemente zu Mehrfacheintrag gruppiert',
      title: 'Elemente zu Mehrfacheintrag gruppieren',
      tooltip:
        'Wähle mindestens zwei Elemente über die Checkboxen aus, um diese zu einem Mehrfacheintrag zusammen zu fügen.',
    },
    delete: {
      subtitle:
        'Das Element wird gelöscht und kann nicht wieder hergestellt werden.',
      text: 'Jetzt Element löschen?',
      title: 'Delete element',
      error:
        'Du verwendest diese Hilfsmittelvorlage aktuell. Soll die angelegten Hilfsmittel ebenfalls gelöscht werden?',
    },
    multi_elements: {
      settings: {
        display: 'Standard View:',
        elements_admin: {
          label: 'Elements visible only to admin',
          placeholder: 'Select elements',
        },
        elements_visible: {
          label: 'Visible elements in the tool',
          placeholder: 'Select elements',
        },
        error: 'Error saving settings',
        sort_by: {
          label: 'By which element should it be primarily sorted?',
          placeholder: 'Select element',
        },
        sort_order: {
          asc: 'ascending',
          desc: 'descending',
          label: 'Sort by',
        },
        title: 'Settings',
        headline_kanban: 'Kanban Settings:',
        kanban_card_description_label: 'Element for Description (optional)',
        kanban_card_title_label: 'Element for Title',
        kanban_card_user_label: 'Element to display User',
        kanban_status_label: 'Element for Status',
        kanban_column_label: 'Element for Columns in Kanban',
      },
    },
    types: {
      favorites: 'Favorites',
      information_display: {
        auto_id: {
          subtitle: 'Information for an ID',
          title: 'Auto-ID',
          prefix: 'Prefix',
          postfix: 'Postfix',
          start_value: 'Start-Value',
        },
        headline: {
          subtitle: 'Trenne Elemente optisch mit einer Überschrift',
          title: 'Headline',
        },
        image: {
          subtitle: 'Für das Anzeigen von Bildern zur Veranschaulichung',
          title: 'Image',
        },
        info: {
          subtitle: 'Für Informationen und Beschreibungen',
          title: 'Infotext',
        },
        title: 'Elemente für Informationsdarstellung',
      },
      information_obtain: {
        contact: {
          subtitle: 'Selection from contacts',
          title: 'Contact',
        },
        date_picker: {
          subtitle: 'Für Datums und Zeitangaben',
          title: 'Date Picker',
        },
        email: {
          subtitle: 'Für die Eingabe von E-Mail Adressen',
          title: 'E-Mail',
        },
        input: {
          subtitle: 'Single, multi-line syntax (e.g. date)',
          title: 'Text- Numberfield',
        },
        number: {
          subtitle: 'Wie ein Textfeld für Zahlen',
          title: 'Zahl',
        },
        reminder: {
          subtitle: 'Für Erinnerungen basierend auf Datum oder Zeit',
          title: 'Reminder',
        },
        telephone: {
          subtitle: 'Für die Eingabe von Telefonnummern',
          title: 'Telefon',
        },
        textarea: {
          subtitle: 'Für längere Texte, die über eine Zeile hinaus gehen',
          title: 'Textarea',
        },
        title: 'Einfache Elemente, um Informationen zu erhalten',
        toggle: {
          subtitle: 'Ja oder Nein? Einfache Entscheidungen',
          title: 'Toggle',
        },
        upload: {
          subtitle: 'Upload files',
          title: 'Files',
        },
      },
      options: {
        checkbox: {
          subtitle: 'Selection of one or more options',
          title: 'Checkbox',
        },
        group: {
          subtitle: 'Selecting a group from the network',
          title: 'Group',
        },
        create_row: {
          subtitle: 'Zum Anzeigen, wer den Eintrag erstellt hat',
          title: 'Ersteller',
        },
        radio_button: {
          subtitle: 'Selecting one option',
          title: 'Radio Button',
        },
        select: {
          subtitle: 'Selection of one or more options',
          title: 'Select',
        },
        title:
          'Elemente mit benutzerdefinierten Auswahloptionen, um Informationen zu erhalten',
        user: {
          subtitle: 'Für die Auswahl von Nutzern deiner Gemeinschaft',
          title: 'Person / User',
        },
      },
      vote: {
        star: {
          subtitle: 'Wohl die bekannteste Form der Bewertung',
          title: 'Sterne 1-n',
        },
        decision: {
          subtitle: 'Lasse für einen Eintrag abstimmen',
          title: 'Entscheidung',
        },
        grade: {
          subtitle: 'Jedem Eintrag können 1-n Punkte vergeben werden',
          title: 'Punkte 1-n',
        },
        map: {
          subtitle: 'Abstimmung für jeden Eintrag mit farbigen Karten',
          title: 'Karte',
        },
        title: 'Elemente zur Abstimmung (Coming soon)',
      },
    },
  },
  print: {
    form: {
      cover: {
        label: 'Cover',
      },
      name: {
        label: 'Bezeichnung deiner Druckansicht',
        placeholder: 'z.B. Protokoll',
      },
    },
    save: 'Save print view',
  },
  publish: {
    alert: 'Vorbereitung zum Teilen beenden?',
    form: {
      button: 'Speichern und veröffentlichen',
      community: {
        choose: 'Choose a community as a sender',
        label:
          'I would like one of my communities to become the sender of the template.',
        description:
          'Describe what your community does and how the tool is used.',
        tos: {
          content1: 'I hereby confirm that I have read the following ',
          content2: 'rules ',
          content3:
            'for sharing resource templates using the open source MIT license.',
          dialog: {
            text1:
              '„Wenn eine Teilnehmerin oder ein Teilnehmer selbst erstellte Hilfsmittel in den Marktplatz einstellt oder Hilfsmittel ( nachfolgend : „Software"), die von anderen Teilnehmerinnen oder Teilnehmern erstellt wurden, aus dem Marktplatz nutzen möchte, so gilt dies unter ausdrücklicher Anerkennung der folgenden Lizenz:',
            text2:
              'Jedem, der eine Kopie dieser Software und der zugehörigen Dokumentationsdateien ( die „Software" ) erhält, wird hiermit kostenlos die Erlaubnis erteil, ohne Einschränkung die Software zu nutzen, einschließlich und ohne Einschränkung der Rechte zum Kopieren, Ändern, Zusammenführen, Veröffentlichen, Verteilen, Unterlizenzieren und / oder Verkaufen von Kopien der Software, und Personen, denen die Software zur Verfügung gestellt wird, dies unter den folgenden Bedingungen zu gestatten:',
            text3:
              'Der obige Urheberrechtshinweis und dieser Genehmigungshinweis müssen in allen Kopien oder wesentlichen Teilen der Software enthalten sein.',
            text4:
              'Die Software wird ohne jegliche ausdrückliche oder stillschweigende Gewährleistung, einschließlich, aber nicht beschränkt auf die Gewährleistung der Marktgängigkeit, der Eignung für einen bestimmten Zweck und der Nichtverletzung von Rechten Dritte, zur Verfügung gestellt . Die Autoren oder Urheberrechtsinhaber sind in keinem Fall haftbar für Ansprüche, Schäden oder andere Verpflichtungen, ob in einer Rechtsstreitigkeit, die sich aus Vertrag, unerlaubter Handlung oder sonstige Gründe stützt, die sich aus, aus oder in Verbindung mit der Software oder der Nutzung oder anderen Verwendungen der Software ergeben.',
            text5:
              'Als Verantwortliche gem. § 7 Abs.1 TMG und § 18 Abs. 1 MStV behalten wir uns vor, Vorschläge für Hilfsmittel ohne Angabe von Gründen von der Veröffentlichung auf unserer Plattform auszuschließen."',
            title: 'Regeln (Open Source Richtlinien- MIT Lizenz)',
          },
          error: 'Den Regeln muss zugestimmt werden',
        },
      },
      description: {
        error: 'Es muss eine Beschreibung vorhanden sein',
        label: 'Beschreibung in kurzen Worten',
        placeholder: 'Diese Hilfsmittelvorlage kann genutzt werden für ...',
      },
      name: {
        error: 'Es muss ein Name eingegeben werden',
        label: 'Name der Hilfsmittelvorlage',
        placeholder: 'z.B. Protokoll',
      },
      screenshot: {
        error: {
          required: 'Es muss ein Screenshot ausgewählt werden',
          too_many: 'Zu viele Screenshots ausgewählt',
        },
        label:
          'Upload an image that should be shown in the detailed view of your resource template in the marketplace.',
      },
      types: {
        community: 'Intern (für meine Gemeinschaft)',
        error: 'A community must be selected',
        label: 'Who should your template be published for?',
        public: 'Mit der Pengueen Community teilen',
        private: 'Intern (nur für mich)',
      },
      use_case: {
        error: 'Es muss ein Anwendungsfall ausgewählt werden',
        label: 'Where should we place your template?',
      },
    },

    notification: {
      subtitle:
        'Wir werden deine Vorlage überprüfen. Du erhältst eine Benachrichtigung, sobald die Vorlage genehmigt wurde.',
      title: 'Erfolgreich zur Überprüfung eingereicht',
    },
    notification_private: {
      subtitle: '',
      title: 'Deine Hilfsmittelvorlage wurde erfolgreich veröffentlicht.',
    },
    subtitle:
      'Publish your resource template privately, for use within your community, or to share with the Pengueen community via the marketplace.',
    title: 'Veröffentliche deine Hilfsmittelvorlage',
  },
  purpose: {
    community: 'Organisation der Gemeinschaft',
    living: 'Für die Lebenswelt',
    title: 'Zweck',
  },
  sections: {
    create: {
      button: 'Create',
      subtitle: 'Gebe deinem Hilfsmittel einen neuen Abschnitt',
      title: 'Add new section',
    },
    delete: {
      note: 'Du kannst diesen Abschnitt noch nicht löschen, da dieser noch Elemente enthält.',
      subtitle:
        'Der Abschnitt wird gelöscht und kann nicht wieder hergestellt werden.',
      text: 'Jetzt Abschnitt löschen?',
      title: 'Abschnitt löschen',
    },
    edit: {
      button: 'Edit',
      subtitle: 'Bearbeite den Abschnitt',
    },
    elements: {
      delete:
        'Du kannst den Mehrfacheintrag nur löschen, wenn alle zugehörigen Elemente gelöscht sind.',
      add: 'Add new element',
      example: {
        description: 'Das ist eine Beispielbeschreibung',
        name: 'Beispielfeldname',
      },
    },
    info: `Wir haben dir beispielsweise einen Abschnitt und ein Textfeld angelegt, sodass du sehen kannst, wie diese funktionieren.
    Du kannst diese Elemente gerne bearbeiten oder löschen.`,
    name: {
      label: 'Bezeichnung des Abschnitts',
      placeholder: 'z.B. Protokollthema',
    },
    restricted: {
      label: 'Abschnitt ist nur für den Pengueen Admin sichtbar',
      title: 'Bestimme die Sichtbarkeit des Abschnitts',
    },
  },
  settings: {
    alert: {
      create: 'Hilfsmittelkreierung beenden?',
      edit: 'Hilfsmitteleditierung beenden?',
    },
    description: {
      label: 'Beschreibung in kurzen Worten',
      placeholder: 'Diese Hilfsmittelvorlage kann genutzt werden für …',
      subtitle:
        'Beschreibe für andere Nutzer, um was es in der Hilfsmittelvorlage geht.',
      title: 'Beschreibe, wofür die Hilfsmittelvorlage verwendet werden kann',
    },
    extra: {
      settings: {
        restricted: 'Darf nur durch Gemeinschaft angelegt werden',
        unique: 'Darf nur einmal angelegt und verwendet werden',
      },
      subtitle:
        'Treffe weitere Einstellungen, um die Nutzung des Hilfsmittels zu spezifizieren.',
      title: 'Gebe weitere Einstellungen des Hilfsmittels an',
    },
    icon: {
      label: 'Wähle ein Icon aus',
      subtitle:
        'Über das Icon findest du das Hilfsmittel später schneller wieder.',
      title: 'Wähle ein Icon für deine Hilfsmittelvorlage aus',
    },
    notification: {
      title: 'Notifications',
      subtitle:
        'Who should be informed later about changes to the created tools in this template?',
      case: 'When',
      template_created: 'Tool is created',
      template_changed: 'Tool is changed*',
      template_changed_explanation:
        '* Notifications for changes to or in multiple entries are configured in the settings of the respective multiple entry',
      inform: 'Inform',
      community_owner: 'Community owner',
      admins: 'Administrators',
      employees: 'Employees',
      following_receiver: 'Following recipients',
      tool_creator: 'Creator of the tool',
      affected_person: 'Affected person**',
      affected_person_explanation:
        '** The person or members of a group to whom this tool has been added; if different from the creator.',
      multi_title: 'Notification Settings',
      multi_subtitle:
        'Who should be notified later about new or changed multiple entries or changes to multiple entries?',
      multielement_created: 'New Multiple Entry (also delete)',
      multielement_changed: 'Change of contents of a multiple entry',
      multielement_creator: 'Creator of the MFE',
      multielement_affected_person: 'Affected person**',
      multielement_changed_explanation:
        '* Nicht vergessen: Markiere diejenigen Elemente des Mehrfacheintrages, deren Veränderung eine Benachrichtigung auslösen soll.',
      multielement_affected_person_explanation:
        '** The person assigned in the MFE or a member of an assigned group; if different from the creator.',
      element:
        'You can trigger notifications when the content of this element is changed.',
      element_changed: 'This element triggers notifications.',
      element_changed_title: 'Output the label in the notification',
      element_changed_content: 'Output the content/value in the notification',
    },
    interface: {
      title: 'Schnittstelle',
      subtitle:
        'Anbindung einer externen (Web-) Anwendung für den Zugriff auf die Daten dieses Hilfsmittels.',
      token_label: 'Schnittstelle-Token',
      token_placeholder: '8923fbb11deee0877fcb69e01db560a1',
      url_label: 'Schnittstelle-URL',
      url_placeholder: 'https://p4.pengueen.de',
    },
    headerimage: {
      title: 'Headergrafik',
      subtitle:
        'Hier kannst du eine Default-Grafik auswählen, die oben im Tool angezeigt werden soll (Kann im Tool noch überschrieben werden).',
      label: 'Bild',
      sublabel:
        'Erlaubte Datentypen: png, jpg, jpeg Breite: 1920px Höhe: 112px',
    },
    name: {
      label: 'Name der Hilfsmittelvorlage',
      placeholder: 'z.B. Protokoll',
      subtitle:
        'Gebe deiner Hilfsmittelvorlage eine verständliche Beschreibung.',
      title: 'Wie soll die Hilfsmittelvorlage heißen?',
    },
    purpose: {
      subtitle:
        'Wähle aus, ob das Hilfsmittel für die Organisation deiner Gemeinschaft ist oder für die Lebenswelt eines Menschen.',
      title: 'Für welchen Zweck kann das Hilfsmittel verwendet werden',
    },
    summary: {
      button: 'Änderungen ansehen',
      description: 'Beschreibung',
      extra: 'Einstellungen',
      name: 'Bezeichnung',
      icon: 'Icon',
      save: 'Save changes',
      success: 'Änderungen wurden gespeichert.',
      subtitle: 'Überprüfe deine Angaben.',
      title: {
        create: 'Passt alles?',
        edit: 'Einstellungen bearbeiten',
      },
    },
    title: 'Create new tool',
  },
  status: {
    blueprint: 'Blueprint',
    community: 'For community',
    published: 'Published',
  },
  use_cases: {
    documentation: 'Documentation, Progress Documentation',
    other: 'Other',
    project_management: 'Project Control',
    form: 'Application, Form',
    files: 'File Storage, Documents',
    records: 'Customer, Employee File, Master Data',
    planning: 'Organization, Planning',
    meeting: 'Event, Meeting',
  },
  workbench: {
    make: 'Vorlagen erstellen',
    community: 'Hilfsmittelvorlagen für',
    mobile: {
      text: `Unsere Hilfsmittelschmiede und die Erstellung deines eigenen Hilfsmittels ist noch nicht für kleinere Bildschirme oder mobile Endgeräte optimiert.
      Für die best mögliche Erfahrung, Wechsel bitte zu einem breiteren Bildschirm.`,
      title: 'Wechsel auf einen größeren Bildschirm',
    },
    personal: 'Deine Hilfsmittelvorlagen',
    title: 'Workbench',
    title_page: 'Workbench',
  },
};
